export const DATE = {
  dateFormat: 'dd/MM/yyyy',
  dateMask: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
};
